import React, { useContext } from 'react';

import { FilterContext } from '../../Context/FilterContext';
import SimpleLink from '../../Form/SimpleLink/SimpleLink';

interface Props {
    toggleVisibility: () => void;
}

const SkinAnalysisLinks: React.FunctionComponent<Props> = (props) => {
    const { makeOnlineAnalysisOverlayVisible } = useContext(FilterContext);
    return (
        <div className="skin-analysis__links">
            <button
                className="simple-link"
                onClick={() => {
                    makeOnlineAnalysisOverlayVisible(true);
                    props.toggleVisibility();
                }}
            >
                <svg className="icon icon--arrow-right">
                    <use xlinkHref="#icon-arrow-right" />
                </svg>
                <span>Online-Hautbild-Analyse durchführen</span>
            </button>
            <SimpleLink
                text="Telefonische Fachberater-Hautbild-Analyse anfragen"
                link={window.__GGConsultantAssignmentUri}
            />
            <SimpleLink
                text="Fachberater Hautbild-Analyse im Einzeltermin anfragen"
                link={window.__GGConsultantAssignmentUri}
            />
        </div>
    );
};

export default SkinAnalysisLinks;
